module.exports = __webpack_public_path__ + "static/img/6bg_7.98c7407.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/6bg_7.png
// module id = 742
// module chunks = 1